import template from './templates';
import getFocusable from '@utils/get-focusable';

const SCROLL_DURATION = 500;

let isActive = window.scrollY >= 50;
const $backToTop = $($.parseHTML(template));

window.addEventListener('scroll', () => {
    if(window.scrollY >= 50 && !isActive) {
        isActive = true;
        $backToTop.show();
    } else if(window.scrollY < 50 && isActive) {
        isActive = false;
        $backToTop.hide();
    }
});

$backToTop.on('click', evt => {
    evt.preventDefault();

    $('html,body').animate({ scrollTop: 0, }, SCROLL_DURATION, () => {
        const $focusable = getFocusable(document.documentElement);
        $focusable.get(0)?.focus();
    });
});

if(process.env.NODE_ENV !== 'development') {
    $(document.body).append($backToTop);

    if(isActive) {
        $backToTop.show();
    }
}
